import env from 'constants/env';
import {Helmet} from 'react-helmet-async';

const GoogleTagManager = () => {
  const gtScript = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-468C7B044B');
  `;

  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KJMZKJBT');`;

  if (env.VITE_ENVIRONMENT_NAME === 'beta') {
    return (
      <Helmet>
        <script>{gtmScript}</script>

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-468C7B044B"
        ></script>

        <script>{gtScript}</script>
      </Helmet>
    );
  }

  return null;
};

export default GoogleTagManager;
